import { ClientState } from 'types/api/attacks/client'

export interface K8sObject {
  annotations: { [key: string]: string }
  availableContainers: K8sContainer[]
  clientId?: string
  clusterId: string
  createdAt: string // Date
  data?: string
  kind: string
  labels: { [key: string]: string }
  name: string
  namespace: string
  ownerReferences: string
  resolved?: boolean
  resolvedContainers: string[]
  teamId?: string
  uid: string
}

export interface K8sContainer {
  name?: string
  state?: string
  uid?: string
  unifiedUid?: string
}

export enum K8sKind {
  DEPLOYMENT = 'Deployment',
  REPLICASET = 'ReplicaSet',
  POD = 'Pod',
  DAEMONSET = 'DaemonSet',
  STATEFULSET = 'StatefulSet',
  DEPLOYMENTCONFIG = 'DeploymentConfig',
  REPLICATIONCONTROLLER = 'ReplicationController',
  ROLLOUT = 'Rollout'
}

export interface Strategy {
  k8sObjects?: K8sObject[]
  k8sObjectsInternal?: K8sObject[]
  count?: number
  percentage?: number
}

export interface K8sClient {
  availableNamespaces: string[]
  // UUID
  clientId: string
  // Human readable identifier
  clusterId: string
  createdAt: Date
  // Same as clientId
  identifier: string
  lastSeen: Date
  objects: K8sObject[]
  state: ClientState
  tags?: { [key: string]: string } | null
  teamId: string
}
